import React from 'react';
import useStyle from './dateInput.style';

interface DateInputProps {
  label?: string;
  error?: string;
  name: string;
  value: string;
  onChange: any;
  minDate: string;
  maxDate: string;
}

export const DateInput = ({
  label,
  error,
  name,
  value,
  onChange,
  minDate,
  maxDate
}: DateInputProps) => {
  const classes = useStyle();
  return (
    <div className={classes.root}>
      {label && <p className={classes.label}>{label}</p>}
      <input
        className={classes.input}
        type="date"
        name={name}
        value={value}
        onChange={onChange}
        min={minDate}
        max={maxDate}
      />
      {error && <p className={classes.inputError}>{error}</p>}
    </div>
  );
};
